import { render, staticRenderFns } from "./DataPanelV.vue?vue&type=template&id=a90b662c&scoped=true"
import script from "./DataPanelV.vue?vue&type=script&lang=js"
export * from "./DataPanelV.vue?vue&type=script&lang=js"
import style0 from "./DataPanelV.vue?vue&type=style&index=0&id=a90b662c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90b662c",
  null
  
)

export default component.exports